import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  videoId: string;
  size?: "sm" | "md" | "lg";
  withLabel?: boolean;
  className?: string;
}

const sizeMap = {
  sm: "w-8 h-8 text-base",
  md: "w-10 h-10 text-lg",
  lg: "w-11 h-11 text-xl",
};

export default function FavoriteButton({
  videoId,
  size = "md",
  withLabel = false,
  className = "",
}: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(videoId);

  return (
    <button
      type="button"
      aria-label={active ? "取消收藏" : "收藏"}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(videoId);
      }}
      className={`flex items-center gap-2 transition-colors cursor-pointer whitespace-nowrap ${
        withLabel ? "px-4 h-11 rounded-md text-sm" : `${sizeMap[size]} rounded-full`
      } ${
        active
          ? "bg-primary-500 text-background-50"
          : "bg-foreground-950/45 text-background-50 hover:bg-primary-500"
      } ${className}`}
    >
      <i className={active ? "ri-heart-3-fill" : "ri-heart-3-line"} />
      {withLabel && <span>{active ? "已收藏" : "收藏"}</span>}
    </button>
  );
}